/** Mirrors enums.MarketingSource (api/app/enums/marketing_source.go). */
export type MarketingSource =
  | "ChatGPT"
  | "Google Ads"
  | "Google My Business"
  | "Google Organic"
  | "LSA"
  | "Previous Client"
  | "Prior Client Referred"
  | "Provider"
  | "Referrals"
  | "Yelp";

export const MARKETING_SOURCES: readonly MarketingSource[] = [
  "ChatGPT",
  "Google Ads",
  "Google My Business",
  "Google Organic",
  "LSA",
  "Previous Client",
  "Prior Client Referred",
  "Provider",
  "Referrals",
  "Yelp",
];
